import { cn } from "./utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("bg-accent animate-pulse rounded-md", className)}
      {...props}
    />
  );
}


// Add this component at the top of your file, after the imports
function ScheduleTableSkeleton() {
  return (
    <>
      {[...Array(5)].map((_, i) => (
        <tr key={`skeleton-${i}`} className="animate-pulse">
          <td className="px-4 py-4">
            <div className="flex items-center gap-2">
              <div className="w-12 h-12 rounded-lg bg-white/5" />
              <div className="space-y-2">
                <div className="h-4 w-14 bg-white/10 rounded" />
                <div className="h-3 w-14 bg-white/5 rounded" />
              </div>
            </div>
          </td>
          <td className="px-6 py-4">
            <div className="h-4 w-24 bg-white/10 rounded" />
          </td>
          <td className="px-6 py-4">
            <div className="flex gap-2">
              <div className="h-6 w-16 bg-white/10 rounded" />
              <div className="h-6 w-12 bg-white/5 rounded" />
            </div>
          </td>
          <td className="px-6 py-4">
            <div className="space-y-1">
              <div className="h-5 w-20 bg-white/10 rounded" />
              <div className="h-3 w-16 bg-white/5 rounded" />
            </div>
          </td>
          <td className="px-6 py-4">
            <div className="h-4 w-24 bg-white/10 rounded" />
          </td>
          <td className="px-6 py-4">
            <div className="h-6 w-16 bg-white/10 rounded-full" />
          </td>
          <td className="px-6 py-4">
            <div className="h-8 w-8 bg-white/10 rounded-lg flex items-center justify-center">
              <div className="flex items-center gap-0.5">
                <div className="w-1 h-1 rounded-full bg-white/30" />
                <div className="w-1 h-1 rounded-full bg-white/30" />
                <div className="w-1 h-1 rounded-full bg-white/30" />
              </div>
            </div>
          </td>
        </tr>
      ))}
    </>
  );
}

function CategoriesTableSkeleton() {
  return (
    <>
      {[...Array(5)].map((_, i) => (
        <tr key={`category-skeleton-${i}`} className="animate-pulse">
          <td className="px-6 py-4">
            <div className="h-5 w-32 bg-white/10 rounded" />
          </td>
          <td className="px-6 py-4">
            <div className="h-6 w-20 bg-white/10 rounded-full" />
          </td>
          <td className="px-6 py-4">
            <div className="h-4 w-24 bg-white/10 rounded" />
          </td>
          <td className="px-6 py-4 text-right">
            <div className="flex justify-end gap-2">
              <div className="h-8 w-8 bg-white/10 rounded-lg flex items-center justify-center">
                <div className="flex items-center gap-0.5">
                  <div className="w-1 h-1 rounded-full bg-white/30" />
                  <div className="w-1 h-1 rounded-full bg-white/30" />
                  <div className="w-1 h-1 rounded-full bg-white/30" />
                </div>
              </div>
            </div>
          </td>
        </tr>
      ))}
    </>
  );
}

// Show skeleton loading component
function ShowsTableSkeleton() {
  return (
    <>
      {[...Array(5)].map((_, i) => (
        <tr key={`category-skeleton-${i}`} className="animate-pulse">
          <td className="px-6 py-4">
            <div className="h-5 w-32 bg-white/10 rounded" />
          </td>
          <td className="px-6 py-4">
            <div className="h-6 w-20 bg-white/10 rounded-full" />
          </td>
          <td className="px-6 py-4">
            <div className="h-4 w-24 bg-white/10 rounded" />
          </td>
          <td className="px-6 py-4">
            <div className="h-4 w-24 bg-white/10 rounded" />
          </td>
          <td className="px-6 py-4 text-right">
            <div className="flex justify-end gap-2">
              <div className="h-8 w-8 bg-white/10 rounded-lg flex items-center justify-center">
                <div className="flex items-center gap-0.5">
                  <div className="w-1 h-1 rounded-full bg-white/30" />
                  <div className="w-1 h-1 rounded-full bg-white/30" />
                  <div className="w-1 h-1 rounded-full bg-white/30" />
                </div>
              </div>
            </div>
          </td>
        </tr>
      ))}
    </>
  )
}

function DailyScheduleSkeleton() {
  return (
    <div className="w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="bg-white/5 border border-white/10 rounded-2xl p-6">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-10 h-10 rounded-lg bg-white/10 animate-pulse" />
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-white/10 rounded w-3/4 animate-pulse" />
                <div className="h-5 bg-white/10 rounded w-1/2 animate-pulse" />
              </div>
            </div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-4 h-4 rounded-full bg-white/10 animate-pulse" />
              <div className="h-4 bg-white/10 rounded w-1/3 animate-pulse" />
            </div>
            <div className="space-y-2">
              <div className="h-3 bg-white/10 rounded animate-pulse" />
              <div className="h-3 bg-white/10 rounded w-5/6 animate-pulse" />
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-center">
        <div className="h-12 w-48 bg-white/10 rounded-lg animate-pulse"></div>
      </div>
    </div>
  )
}

export { Skeleton, ScheduleTableSkeleton, CategoriesTableSkeleton, ShowsTableSkeleton, DailyScheduleSkeleton };
